<template>
  <div class="navbar navbar-style-1" style="top: unset">
    <div class="navbar-inner">
      <a href="/" @click="toggleMain" class="link back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z"
              fill="black"/>
        </svg>
      </a>
      <div class="title">{{ category['category'].title }}</div>
    </div>
  </div>

  <div class="page-content pt-5">
    <div class="searchbar-backdrop"></div>

    <div class="container">
      <form data-search-container=".search-list" data-search-in=".item-title" id="searchForm"
            class="searchbar searchbar-init search-box list-search-bx">
        <div class="searchbar-inner">
          <div class="searchbar-input-wrap">
            <input type="search" placeholder="Procurar" v-model="search"/>
            <i class="searchbar-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.65925 19.3102C11.8044 19.3103 13.8882 18.5946 15.5806 17.2764L21.9653 23.6612C22.4423 24.1218 23.2023 24.1086 23.663 23.6316C24.1123 23.1664 24.1123 22.4288 23.663 21.9636L17.2782 15.5788C20.5491 11.3682 19.7874 5.30335 15.5769 2.03244C11.3663 -1.23846 5.30149 -0.476784 2.03058 3.73376C-1.24033 7.9443 -0.478646 14.0092 3.73189 17.2801C5.42702 18.597 7.51269 19.3113 9.65925 19.3102ZM4.52915 4.52732C7.36245 1.69396 11.9561 1.69391 14.7895 4.52721C17.6229 7.36052 17.6229 11.9542 14.7896 14.7876C11.9563 17.6209 7.36261 17.621 4.52925 14.7877C4.5292 14.7876 4.5292 14.7876 4.52915 14.7876C1.69584 11.9749 1.67915 7.39796 4.49181 4.56465C4.50424 4.55217 4.51667 4.53974 4.52915 4.52732Z" fill="#C9C9C9"/>
              </svg>
            </i>
          </div>
        </div>
      </form>
      <div class="list simple-list searchbar-not-found">
        <ul><li>Sem resultados.</li></ul>
      </div>
    </div>

    <div class="container">
      <div data-space-between="0" data-slides-per-view="auto" data-centered-slides="false"
           class="swiper swiper-init tabbar tab-style-2">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <a href="#tab-1" class="tab-link tab-link-active">Produtos</a>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs-swipeable-wrap mt-30 tabs-height-auto">
      <div class="tabs">
        <div id="tab-1" class="tab tab-active">
          <div class="list search-list mt-0 mb-20 container searchbar-found item-list">
            <ul class="row" style="gap:0.5em">
              <li class="col-100 medium-50" v-for="item in filteredProducts" :key="item.id">
                <div class="wishlist-bx" style="box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05)">
                  <div class="dz-info">
                    <div class="dz-head">
                      <div style="display: flex; justify-content: space-between">
                        <h6 class="item-title">
                          <a href="/">{{ item.title }}</a>
                        </h6>
                        <div>
                          <img style="width: 24px; height: 24px" :src="`${ allergen }`"
                               v-for="allergen in item.allergen_image"
                               :key="allergen.id"/>
                        </div>
                      </div>
                      <ul class="tag-list" style="font-size: 12px; padding: 1%">
                        <li v-if="item.allergen">
                          <div style="display: flex; align-items: center;">
                            <div style="padding: 2px" v-if="item.allergen && item.allergen.length">
                              Este produto contém: {{ item.allergen.filter(a => a).join(', ') }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="dz-img">
                      <img :src="getProductImage(item)"
                           alt="Product Image"
                           class="product-img"
                           loading="lazy"
                            width="140"
                            height="140"/>
                    </div>
                    <div class="dz-meta">
                      <ul>
                        <li class="price">{{ item.price }} €</li>
                        <div class="stepper stepper-init stepper-round" :class="{ opacElement: !item.available }"
                             style="border: 1px solid #c4c4c4; height: 42px">
                          <div class="stepper-button-minus" :class="{ disabled: !item.available }" style="border: 0"
                               @click="removeFromCard(`${ item.id }`)"></div>
                          <div class="stepper-input-wrap" style="border: 0">
                            <input style="font-size: 18px;color: #000;" type="text" :value="itemQuantity(`${ item.id }`)" min="0" max="100" step="1" readonly/>
                          </div>
                          <div class="stepper-button-plus" :class="{ disabled: !item.available }"
                               @click="addToCart(`${ item.id }`)"
                               style="border: 0"></div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <ul style="text-align: center;" v-if="filteredProducts.length === 0">
              <li>Sem resultados.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'ProductCategory',
  props: ['category'],
  emits: ['toggle-main', 'toggle-cart'],

  data() {
    return {
      search: '',
      cartUpdated: false,
      cartOpen: false,
    };
  },
  methods: {
    addToCart(id) {
      this.$store.commit('addToCard', this.category['products'].find(i => i.id === id))
    },
    removeFromCard(id) {
      this.$store.commit('removeFromCard', this.category['products'].find(i => i.id === id))
    },
    toggleCart() { this.$emit('toggle-cart', true); },
    toggleMain() { this.$emit('toggle-main', true); },

    getProductImage(item) {
      const categoryTitle = this.category['category'].title;

      // Mapeamento de Pastas
      const folders = {
        "Baguetes": "baguetes/",
        "Tostas": "tostas/",
        "Torradas": "torradas/",
        "Bolos": "bolos/",
        "Bebidas Quentes": "bebidas quentes/",
        "Bebidas Frias": "bebidas frias/",
        "Gelados": "gelados/",
        "Pizzas": "pizzas/",
        "Nuggets": "nuggets/"
      };

      // Mapeamento de IDs para Ficheiros
      const fileMap = {
        // Baguetes
        "80": "baguette branca com fiambre.png",
        "81": "baguette branca com queijo.png",
        "82": "baguette branca mista.png",
        "83": "baguette branca com pasta de atum.png",
        "84": "baguette multicereais com pasta de delicias do mar.png",
        "85": "baguette multicereais com fiambre.png",
        "86": "baguette multicereais com queijo.png",
        "87": "baguette multicereais mista.png",
        "88": "baguette multicereais com pasta de atum.png",
        "89": "baguette branca com pasta de delicias do mar.png",
        "90": "baguette sem gluten com queijo.png",
        "91": "baguette sem gluten com fiambre.png",
        "92": "baguette sem gluten mista.png",
        "93": "baguette sem gluten com pasta de atum.png",
        "96": "baguette sem gluten com pasta de delicias do mar.png",

        // Tostas
        "32": "tosta de fiambre.png",
        "33": "tosta de queijo.png",
        "34": "tosta mista.png",
        "35": "tosta de pasta de atum.png",
        "36": "tosta de pasta de delicias do mar.png",
        "140": "tosta amendoim compota.png",

        // Torradas
        "30": "torrada com compota de abobora.png",
        "31": "torrada com manteiga.png",
        "130": "torrada com compota de frutos vermelhos.png",
        "134": "torrada com creme de barrar de bolachas belgas Lotus Biscoff.png",

        // Bolos
        "42": "nata.png",
        "111": "tarte_maçã.png",

        // Bebidas Quentes
        "1": "Café.png", "3": "Café.png", "4": "Café.png", "107": "Café.png", "109": "Café.png",
        "5": "chinesa.png",
        "2": "galão.png",
        "7": "Chá.png", "54": "Chá.png", "55": "Chá.png", "56": "Chá.png", "57": "Chá.png", "58": "Chá.png", "59": "Chá.png",
        "60": "chocolate quente.png",

        // Bebidas Frias
        "9": "atlantida_semgas_22_final.jpg",
        "10": "Coral_PuroMalte 2019.jpg",
        "11": "Coral_STOUT 20cl_2022.jpg",
        "15": "ucal.png",
        "16": "brisa-maca-0_36Lt-800x800-1.jpg",
        "17": "Brisa Maracuja_36CL 2017.jpg",
        "19": "compal manga cenoura laranja.png",
        "20": "compal pessego.png",
        "21": "compal laranja.png",
        "23": "compal maracuja.png",
        "45": "cerveja pressão.png",
        "48": "Laranjada 33cl.jpg",
        "49": "Brisa-Maracuja-sem-acucar-036.jpg",
        "50": "compal pera.png",
        "51": "c.-frutos-vermelhos-0.2l.png",
        "52": "Atlantida 50 cl_blue .jpg",
        "53": "atlantida_gas_22_final.jpg",
        "61": "fuze-tea-limao-vidro-300ml-produto.jpg",
        "62": "fuze-tea-pessego-vidro-300ml-produto.jpg",
        "63": "fuze-tea-manga-ananas-vidro-300ml-produto.jpg",
        "65": "coca-cola-original-vidro-350ml-gotas.png",
        "68": "coca-cola-zero-acucar-vidro-350ml-gotas.png",
        "69": "fanta-laranja-vidro-350ml.png",
        "70": "fanta-ananas-vidro-350ml-gotas.png",
        "97": "monster.jpg",
        "99": "bandida maça.png",
        "100": "água com limão - castello.png",
        "101": "sprite-vidro-350ml-gotas.png",
        "102": "coca-cola-zero-baunilha-lata-sleek-330ml-gotas.png",
        "103": "monster_energy_ultra-350x350.png",
        "141": "pepsi.jpg",
        "142": "pepsi.jpg",
        "145": "pepsi.jpg",

        // Gelados
        "112": "calipo limão.png",
        "113": "perna de pau.png",
        "114": "solero exotic.jpg",
        "115": "cornetto filipino.png",
        "116": "CORNETTO-CLASSIC-VANILLA-600x600.png",
        "117": "cornetto morango.png",
        "118": "filipinos sandwich.png",
        "119": "magnum sandwich.jpg",
        "120": "Magnum Double Gold billionaire.jpg",
        "121": "Magnum chocolate branco.png",
        "122": "Magnum de amêndoas.png",
        "124": "Calippo de morango.jpg",

        // Pizzas
        "131": "pizza romana.jpg",
        "132": "pizza pepperoni.jpg",
        "133": "pizza margerita.png",
        "135": "pizza estacoes.jpg",

        //nuggets
        "138": "10NuggetsFrango.png",
        "139": "5NuggetsFrango.png"
      };

      const folder = folders[categoryTitle];
      const fileName = fileMap[item.id];

      // Se encontrarmos o mapeamento, retorna o caminho construído
      if (folder && fileName) {
        return `/assets/img/products/${folder}/${fileName}`;
      }

      // Fallback: se o item tiver imagem, usa essa, senão usa o placeholder
      return item.image && item.image.length > 5 ? item.image : '/assets/img/placeholder.png';
    }
  },

  computed: {
    filteredProducts() {
      return this.category['products'].filter(product => (product.title.toLowerCase().includes(this.search.toLowerCase())));
    },
    ...mapGetters(['getItemQuantity']),
    itemQuantity() {
      return (id) => this.getItemQuantity(this.category['products'].find(i => i.id === id));
    },
  },

  mounted() {
    document.getElementById('searchForm').addEventListener('keypress', event => {
      if (event.key === 'Enter') { event.preventDefault(); }
    });
  },
};
</script>

<style>
  .opacElement { opacity: 0.3 !important; pointer-events: none !important; }
  .product-img { width: 100px; height: 100px; object-fit: contain; border-radius: 8px; }
</style>

